import { apiRequest } from './client';
import type { AccountStatus, AdminUser } from '../types';

export const RESET_TOKEN_KEY = 'homehero_admin_reset_token';
export const RESET_EMAIL_KEY = 'homehero_admin_reset_email';

type AuthRecord = {
  _id: string;
  name?: string;
  email: string;
  role?: string;
  isDeactivatedByAdmin?: boolean;
};

type LoginResponseData = {
  authRecord: AuthRecord;
  token: string;
};

const mapAdminUser = (authRecord: AuthRecord): AdminUser => ({
  id: authRecord._id,
  name: authRecord.name?.trim() || 'Admin',
  email: authRecord.email,
  role: authRecord.role === 'admin' ? 'Admin' : authRecord.role || 'Admin',
  status: (authRecord.isDeactivatedByAdmin ? 'Suspended' : 'Active') as AccountStatus,
});

export const authApi = {
  login: async (email: string, password: string): Promise<{ token: string; user: AdminUser }> => {
    const data = await apiRequest<LoginResponseData>('/admin/auth/login', {
      method: 'POST',
      body: { email, password },
    });

    return {
      token: data.token,
      user: mapAdminUser(data.authRecord),
    };
  },

  logout: async (): Promise<void> => {
    await apiRequest('/admin/auth/logout', {
      method: 'POST',
      auth: true,
    });
  },

  forgotPassword: async (email: string): Promise<void> => {
    await apiRequest('/admin/auth/forgot-password', {
      method: 'POST',
      body: { email },
    });
  },

  verifyResetOtp: async (email: string, otp: string): Promise<string> => {
    const data = await apiRequest<{ token: string }>('/admin/auth/verify-reset-otp', {
      method: 'POST',
      body: { email, otp },
    });
    sessionStorage.setItem(RESET_TOKEN_KEY, data.token);
    return data.token;
  },

  resetPassword: async (newPassword: string, token: string): Promise<void> => {
    await apiRequest('/admin/auth/reset-password', {
      method: 'POST',
      body: { newPassword },
      token,
    });
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiRequest('/admin/auth/change-password', {
      method: 'POST',
      auth: true,
      body: { currentPassword, newPassword },
    });
  },
};
